import React from 'react'

export default function (){

    return(
        <svg viewBox="0 0 1440 75">
            <polyline 
                points="100,35 200,25 300,40 400,20 500,35 600,25 700,35 800,25 900,40 1000,20 1100,35 1200,25 1340,25" 
                style={{fill: "none", stroke: "#3f51b5", strokeWidth: 3}}
            />
        </svg>
    )
}